import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { CoerceBoolean } from '@slidebean/hydra/coercion';

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class CenterComponent {
    constructor() {
        this.grow = true;
    }
    get display() {
        return 'flex';
    }
    get justifyContent() {
        return 'center';
    }
    get alignItems() {
        return 'center';
    }
    get flexFlow() {
        return 'column wrap';
    }
    get width() {
        return this.grow ? '100%' : '';
    }
    get height() {
        return this.grow ? '100%' : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CenterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: CenterComponent, selector: "div[hy-center], hy-center", inputs: { grow: "grow" }, host: { properties: { "style.display": "this.display", "style.justify-content": "this.justifyContent", "style.align-items": "this.alignItems", "style.flex-flow": "this.flexFlow", "style.width": "this.width", "style.height": "this.height" } }, ngImport: i0, template: ` <ng-content></ng-content> `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
__decorate([
    CoerceBoolean()
], CenterComponent.prototype, "grow", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CenterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'div[hy-center], hy-center',
                    template: ` <ng-content></ng-content> `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { grow: [{
                type: Input
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }], justifyContent: [{
                type: HostBinding,
                args: ['style.justify-content']
            }], alignItems: [{
                type: HostBinding,
                args: ['style.align-items']
            }], flexFlow: [{
                type: HostBinding,
                args: ['style.flex-flow']
            }], width: [{
                type: HostBinding,
                args: ['style.width']
            }], height: [{
                type: HostBinding,
                args: ['style.height']
            }] } });
const DIRECTIVES = [CenterComponent];
class CenterModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CenterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: CenterModule, declarations: [CenterComponent], exports: [CenterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CenterModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: CenterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CenterComponent, CenterModule };
